import React, { useEffect, useState, useRef, createElement } from 'react';
import { BookOpen, CheckCircle2, Download, ShieldCheck, Lock, FileText, User, Mail, Phone, Globe, X, ArrowRight, Sparkles, Star, Clock, TrendingUp, Home, DollarSign, Zap, Target, Briefcase, XCircle, AlertTriangle, HelpCircle, MapPin, Quote, Award } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { DownloadNotification } from '../components/DownloadNotification';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function NineToFivePage() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const navigate = useNavigate();
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', '9to5-LandingView');
    window.fbq('init', '4285913388317138');
    window.fbq('trackSingle', '4285913388317138', 'PageView');
    window.fbq('trackSingle', '4285913388317138', 'ViewContent', {
      content_name: '9-to-5 Landing Page',
      source: '/9-to-5'
    });
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const finalName = nameRef.current?.value?.trim() || name.trim();
    const finalEmail = emailRef.current?.value?.trim() || email.trim();
    const finalPhone = phoneRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (finalPhone && finalPhone.length < 7) {
      alert('Por favor ingresa un teléfono válido o déjalo en blanco');
      return;
    }
    if (finalPhone && !smsConsent) {
      alert('Por favor marca la casilla de consentimiento de SMS para continuar.');
      return;
    }
    setIsSubmitting(true);
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: '9-to-5 Guide'
        });
      }
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: finalName,
          email: finalEmail,
          phone: finalPhone ? `${areaCode}${finalPhone}` : '',
          first_name: finalName.split(' ')[0],
          last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
          full_name: finalName,
          fullPhone: finalPhone ? `${areaCode}${finalPhone}` : '',
          areaCode: areaCode,
          source: '/9-to-5',
          page_path: '/9-to-5',
          tag: '9-to-5-guide',
          sms_consent: smsConsent,
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          action_source: 'website'
        })
      });
      navigate('/escapa-del-dealership-gracias');
    } catch (err) {
      console.error('Submit error:', err);
      navigate('/escapa-del-dealership-gracias');
    } finally {
      setIsSubmitting(false);
    }
  };
  const painPoints = ['Llevas años en el mismo trabajo y tu cuenta bancaria se ve igual que hace 5 años', 'Vives para el viernes — odias los domingos en la tarde', 'Tu jefe te trata como reemplazable, porque LO ERES en su sistema', 'Mes tras mes llegas justo al fin de mes. Cero ahorro real.', 'Si te enfermas 30 días seguidos, tu economía colapsaría', 'Pides permiso para ir al doctor, llevar a tu hijo al pediatra', 'Tus hijos están creciendo sin que tú estés presente', 'Te sientes mentalmente cansado TODO el tiempo'];
  const caseStudies = [{
    name: 'Andrés',
    age: 38,
    role: 'Vendedor Toyota',
    city: 'Phoenix',
    before: '$5,500/mes · 70 horas semanales · hijos crecían sin él',
    after: '$18–22K/mes desde casa · va a TODOS los partidos',
    quote: 'Lo único que me detenía era no saber CÓMO.'
  }, {
    name: 'María',
    age: 52,
    role: 'Cajera Walmart',
    city: 'Houston',
    before: '$2,400/mes · divorciada · pensaba que era tarde',
    after: '$13–16K/mes · pagó universidad de cash a su hijo',
    quote: 'Pensé que para mí ya no había salida.'
  }, {
    name: 'Roberto',
    age: 52,
    role: 'Oficinista Seguros',
    city: 'Orlando',
    before: '$80K/año pero quemado · 18 años en aseguradora',
    after: '$22–28K/mes · vacaciones cuando quiere',
    quote: 'A los 52 era tarde. Estaba equivocado.'
  }, {
    name: 'Daniel',
    age: 22,
    role: 'Mesero',
    city: 'Miami',
    before: '$500–800/sem en propinas · vivía con su mamá',
    after: '$11–15K/mes · le compró carro a su mamá',
    quote: 'Mi mamá ya no limpia casas.'
  }, {
    name: 'Carolina',
    age: 34,
    role: 'Ama De Casa',
    city: 'Houston',
    before: '$0 propio · dependía 100% del esposo',
    after: '$13–16K/mes · gana MÁS que su esposo',
    quote: 'Mis hijos van a escuelas privadas ahora.'
  }];
  const chapters = [{
    n: '01',
    title: 'La Trampa Del 9-5',
    desc: 'Las 4 cuerdas invisibles del jefe'
  }, {
    n: '02',
    title: 'Trabajo Lineal Vs Exponencial',
    desc: ''
  }, {
    n: '03',
    title: 'El Modelo Completo Que Cambió Mi Vida',
    desc: ''
  }, {
    n: '04',
    title: '5 Historias Reales Con Números Mes A Mes',
    desc: ''
  }, {
    n: '05',
    title: 'Por Qué AHORA Es El Mejor Momento',
    desc: ''
  }, {
    n: '06',
    title: 'Las 4 Fuentes Gratuitas Para 50 Clientes',
    desc: ''
  }, {
    n: '07',
    title: 'Los 5 Mensajes WhatsApp Word-By-Word',
    desc: ''
  }, {
    n: '08',
    title: 'Tabla Completa De Precios Por Nicho',
    desc: ''
  }, {
    n: '09',
    title: 'Tu Plan De 60 Días Día Por Día',
    desc: ''
  }, {
    n: '10',
    title: 'Tu Siguiente Paso',
    desc: ''
  }];
  const faqs = [{
    q: '¿Es realmente GRATIS?',
    a: 'Sí. 100% gratis. Solo te pido tu email. NO te voy a pedir tarjeta de crédito. NO hay "pequeña letra".'
  }, {
    q: '¿Cómo recibo la guía?',
    a: 'Directamente a tu correo en menos de 60 segundos. Si no llega, revisa spam.'
  }, {
    q: '¿Tengo que saber tecnología?',
    a: 'NO. La IA hace el trabajo técnico. Tú solo necesitas saber QUÉ pedirle. La guía te lo explica todo en español.'
  }, {
    q: '¿Funciona si no soy ciudadano americano?',
    a: 'Sí. Aplica para cualquier latino que opera legalmente en USA.'
  }, {
    q: '¿Funciona si trabajo 40–60 horas a la semana?',
    a: 'Sí. María lo hizo trabajando full-time en Walmart. Andrés mientras vendía carros 70 horas. Bastan 2 horas al día.'
  }, {
    q: '¿Tengo que renunciar a mi trabajo actual?',
    a: 'NO. Te RECOMIENDO mantenerlo. Renuncias cuando tu ingreso paralelo supere tu salario. Cero riesgo.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'Mis alumnos cierran su primer cliente entre día 14 y día 30. En 60 días suelen tener entre $3,000 y $8,000 facturados.'
  }, {
    q: '¿Por qué la das gratis?',
    a: 'Esta guía es la primera puerta. Mi modelo de negocio es enseñar el sistema completo. Si te gusta, vas a querer ver más. Si no, no me debes nada.'
  }];
  const featuredTestimonials = [{
    quote: 'Lo único que me detenía era no saber CÓMO. Esta guía me dio el CÓMO.',
    name: 'Andrés',
    detail: '38 · Phoenix'
  }, {
    quote: '52 años, divorciada, cajera de Walmart. Esta guía me cambió la vida.',
    name: 'María',
    detail: '52 · Houston'
  }, {
    quote: 'Pensé que a los 52 era tarde. Mi edad fue mi VENTAJA. Mes 3: $19,500.',
    name: 'Roberto',
    detail: '52 · Orlando'
  }];
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-3749" data-mp="3bzirev9l26uz">
      <noscript data-id="element-3750" data-mp="3gx11wq390u53">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3751" data-mp="3gxkhi05ff6fy" />
      </noscript>

      {/* Ambient background glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-3752" data-mp="3h46cn53y8uce" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-3753" data-mp="38b30d051injc" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-3754" data-mp="3vxhv060e2mxy" />

      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-3755" data-mp="3m1y1trd7m2cw" />

      {/* ============ FLOATING HEADER ============ */}
      <header className="fixed top-3 md:top-5 left-0 right-0 z-50 px-3 md:px-6 pointer-events-none" data-id="element-3756" data-mp="2fmxhkixjr8m5">
        <div className="max-w-5xl mx-auto pointer-events-auto" data-id="element-3757" data-mp="280a4ne4n4uo2">
          <div className="relative bg-[#0f1b35]/80 backdrop-blur-xl border border-amber-500/25 rounded-full shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6),0_0_30px_-10px_rgba(245,158,11,0.3)]" data-id="element-3758" data-mp="233jo6poxbx24">
            <div className="flex items-center justify-between gap-3 pl-3 pr-2 md:pl-5 md:pr-2.5 py-2 md:py-2.5" data-id="element-3759" data-mp="2c2x0rr8ch1r2">
              <div className="flex items-center gap-2.5 min-w-0" data-id="element-3760" data-mp="1od2r1ijbntb1">
                <div className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-amber-500/15 border border-amber-500/40 flex-shrink-0" data-id="element-3761" data-mp="1kc92cmy22ah3">
                  <BookOpen className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400" data-id="element-3762" data-mp="1y58dydupvkjd" />
                </div>
                <div className="flex flex-col leading-none min-w-0" data-id="element-3763" data-mp="1tbmc7gq3d12c">
                  <span className="text-amber-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.18em] leading-none" data-id="element-3764" data-mp="15mb9vut3eym3">
                    Guía Gratuita
                  </span>
                  <span className="text-white text-xs md:text-sm font-black tracking-tight mt-1 truncate" data-id="element-3765" data-mp="30rasvyczqhf3">
                    Cómo Escapar Del 9-5
                  </span>
                </div>
              </div>

              <div className="hidden lg:flex items-center gap-2 px-3" data-id="element-3766" data-mp="3ahne7ssmqema">
                <Briefcase className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-3767" data-mp="3ffx902afzd7d" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-3768" data-mp="2hrwwl9rsgulf">
                  Empleados Latinos
                </span>
                <span className="inline-block w-px h-3.5 bg-amber-500/25" data-id="element-3769" data-mp="2mskvsiq68hqq" />
                <Globe className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-3770" data-mp="2roji80rxvpoi" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-3771" data-mp="2vs7p0h8qyh8p">
                  En USA
                </span>
              </div>

              <button type="button" onClick={() => setShowModal(true)} className="group flex items-center gap-1.5 md:gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[10px] md:text-xs uppercase tracking-tight rounded-full px-3.5 md:px-5 py-2 md:py-2.5 shadow-[0_8px_25px_-8px_rgba(245,158,11,0.6)] hover:shadow-[0_8px_25px_-5px_rgba(245,158,11,0.8)] transition-all duration-300 flex-shrink-0 whitespace-nowrap" data-id="element-3772" data-mp="azw4690swnzw">
                <Download className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-3773" data-mp="1ct0agv86ognp" />
                <span className="hidden sm:inline" data-id="element-3774" data-mp="17tnftob2m5ak">Descargar Gratis</span>
                <span className="sm:hidden" data-id="element-3775" data-mp="17vrtgxyruio1">Descargar</span>
                <ArrowRight className="w-3.5 h-3.5 md:w-4 md:h-4 transition-transform group-hover:translate-x-0.5" data-id="element-3776" data-mp="13t3jgmybn5ph" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-6xl mx-auto px-4 sm:px-5 lg:px-8 pt-20 md:pt-28 pb-12" data-id="element-3777" data-mp="2y51rwmot3xkb">
        {/* ============ SECTION 1 — HERO ============ */}
        <section className="mb-16 md:mb-24 text-center" data-id="element-3778" data-mp="1pw2x61hnnuck">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-3.5 py-1.5 mb-5 md:mb-6" data-id="element-3779" data-mp="1pwm4ypdld2cv">
            <AlertTriangle className="w-3.5 h-3.5 text-red-400" data-id="element-3780" data-mp="1gvejj7w6bw07" />
            <span className="text-red-400 text-[10px] md:text-xs font-black uppercase tracking-[0.18em] leading-none" data-id="element-3781" data-mp="1guwh1tix4lju">
              Para Empleados Latinos Cansados Del 9-5
            </span>
          </div>

          <h1 className="text-[2rem] sm:text-[2.5rem] md:text-5xl lg:text-[4rem] xl:text-[4.5rem] font-black leading-[1.03] tracking-tight mb-5 md:mb-6 max-w-4xl mx-auto" data-id="element-3782" data-mp="174a4y9aeud5w">
            Cómo Escapar Del 9-5
            <br data-id="element-3783" data-mp="y2tuk1jlib1o" />
            <span className="relative inline-block" data-id="element-3784" data-mp="126i1qj4bf4me">
              <span className="relative z-10 text-amber-400" data-id="element-3785" data-mp="127b8vl76rw52">
                En Los Próximos 60 Días
              </span>
              <span className="absolute bottom-1 left-0 w-full h-2.5 md:h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-3786" data-mp="o8trs6bsdhw4" />
            </span>
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto mb-8 md:mb-10" data-id="element-3787" data-mp="9jic5ggkvgvw">
            Descarga GRATIS la guía de{' '}
            <span className="text-white font-semibold" data-id="element-3788" data-mp="4nbesc28zdpk">30 páginas</span> que
            está leyendo cualquier empleado latino en USA que quiera generar{' '}
            <span className="text-white font-semibold" data-id="element-3789" data-mp="eibrleffdhyp">
              $5,000–$15,000 EXTRAS al mes
            </span>{' '}
            desde casa — sin renunciar primero, sin invertir capital, sin saber
            tecnología.
          </p>

          {/* Book image */}
          <div className="relative flex flex-col items-center mb-10 md:mb-14" data-id="element-3790" data-mp="1298slw5omuv6">
            <div className="relative w-full max-w-2xl lg:max-w-3xl" data-id="element-3791" data-mp="x9mdfh6an4jq">
              <div className="hidden md:flex absolute top-4 left-0 lg:-left-6 z-20 bg-[#0f1b35] border border-amber-500/30 rounded-2xl px-4 py-3 shadow-2xl" data-id="element-3792" data-mp="xae9su7pt6b2">
                <div className="flex items-center gap-2.5" data-id="element-3793" data-mp="178lf2fsn5zx8">
                  <div className="w-9 h-9 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center" data-id="element-3794" data-mp="175z7ig5r3kf0">
                    <TrendingUp className="w-4 h-4 text-emerald-400" data-id="element-3795" data-mp="1j9a9x4x11dic" />
                  </div>
                  <div className="text-left" data-id="element-3796" data-mp="1o8mxjrvq2olz">
                    <div className="text-[10px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3797" data-mp="1o7va54ca3x6s">
                      Ingreso meta
                    </div>
                    <div className="text-sm font-black text-white leading-tight" data-id="element-3798" data-mp="1x0oqz67dj4mr">
                      $5K–$15K/mes
                    </div>
                  </div>
                </div>
              </div>

              <div className="hidden md:flex absolute bottom-4 right-0 lg:-right-6 z-20 bg-[#0f1b35] border border-amber-500/30 rounded-2xl px-4 py-3 shadow-2xl" data-id="element-3799" data-mp="27079rjbjskd8">
                <div className="flex items-center gap-2.5" data-id="element-3800" data-mp="cm6awyfzzxd5">
                  <div className="w-9 h-9 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center" data-id="element-3801" data-mp="cnpvv2clmwl9">
                    <FileText className="w-4 h-4 text-amber-400" data-id="element-3802" data-mp="2uvj17wqwuwob" />
                  </div>
                  <div className="text-left" data-id="element-3803" data-mp="2q4j4oslpegmc">
                    <div className="text-[10px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3804" data-mp="2q3hjhvaz4dqw">
                      Contenido
                    </div>
                    <div className="text-sm font-black text-white leading-tight" data-id="element-3805" data-mp="2h4dwig8ore74">
                      30 páginas
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute inset-0 bg-amber-400/20 blur-[120px] rounded-full scale-90 pointer-events-none" data-id="element-3806" data-mp="39s0c6mv6u9ac" />

              <img src="https://cdn.magicpatterns.com/uploads/3koR9Um6Z3JLvhRxNTnoti/WEBINAR_BONUS_GUIDE_BOOK.png" alt="Cómo Escapar Del 9-5 — Guía Gratis para empleados latinos en USA" className="relative w-full h-auto drop-shadow-[0_30px_60px_rgba(245,158,11,0.35)] hover:scale-[1.02] transition-transform duration-500" data-id="element-3807" data-mp="34rm1sy646n95" />
            </div>

            {/* Mobile badges */}
            <div className="flex md:hidden items-stretch justify-center gap-2.5 mt-5 w-full px-2" data-id="element-3808" data-mp="3ogx0yj821n5k">
              <div className="flex-1 flex items-center gap-2 bg-[#0f1b35] border border-amber-500/30 rounded-xl px-3 py-2.5 shadow-xl" data-id="element-3809" data-mp="3tgjdsrjz11du">
                <div className="w-8 h-8 rounded-lg bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3810" data-mp="3ektpunv86e6h">
                  <TrendingUp className="w-4 h-4 text-emerald-400" data-id="element-3811" data-mp="b1qqkzofq4cf" />
                </div>
                <div className="text-left min-w-0" data-id="element-3812" data-mp="g13m08tdgjqm">
                  <div className="text-[9px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3813" data-mp="g0lhkowk2z7m">
                    Ingreso meta
                  </div>
                  <div className="text-[12px] font-black text-white leading-tight truncate" data-id="element-3814" data-mp="6as9hxvmh284">
                    $5K–$15K/mes
                  </div>
                </div>
              </div>

              <div className="flex-1 flex items-center gap-2 bg-[#0f1b35] border border-amber-500/30 rounded-xl px-3 py-2.5 shadow-xl" data-id="element-3815" data-mp="ys4jeseug782">
                <div className="w-8 h-8 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3816" data-mp="2jgp0jaxdoj2h">
                  <FileText className="w-4 h-4 text-amber-400" data-id="element-3817" data-mp="2t7tjelq6co2l" />
                </div>
                <div className="text-left min-w-0" data-id="element-3818" data-mp="2o9036lji6iyq">
                  <div className="text-[9px] text-gray-400 uppercase tracking-wider font-bold leading-tight" data-id="element-3819" data-mp="2oab50fte1gn7">
                    Contenido
                  </div>
                  <div className="text-[12px] font-black text-white leading-tight truncate" data-id="element-3820" data-mp="1vkksucbbgotq">
                    30 páginas
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile CTA */}
            <div className="md:hidden mt-5 px-2 w-full" data-id="element-3821" data-mp="25hpgyhoq2ud6">
              <button type="button" onClick={() => setShowModal(true)} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base uppercase tracking-tight rounded-2xl py-5 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 overflow-hidden" data-id="element-3822" data-mp="3kyzbcevqrfgs">
                <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-3823" data-mp="31r9tnpjt3zh0">
                  <Download className="w-5 h-5" data-id="element-3824" data-mp="3fq9hiuzhwac4" />
                  Descargar La Guía Gratis
                  <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-3825" data-mp="3aok3d6gz7gjt" />
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-3826" data-mp="3on9zojvz1c74" />
              </button>
            </div>
          </div>

          {/* Desktop CTA + Trust */}
          <div className="max-w-md mx-auto" data-id="element-3827" data-mp="3tifuy9b9k37v">
            <button type="button" onClick={() => setShowModal(true)} className="hidden md:block group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-2xl py-5 md:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-3828" data-mp="c7g7ut9u85n8">
              <span className="relative z-10 flex items-center justify-center gap-2.5" data-id="element-3829" data-mp="lvljuq9ukyz5">
                <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-3830" data-mp="76yzub99zj1l" />
                Descargar La Guía Gratis
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-3831" data-mp="bxfgs5cb1msp" />
              </span>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-3832" data-mp="3ucpzgrmoiu0z" />
            </button>

            <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-3833" data-mp="3ke0shtwbmtzi">
              {['100% Gratis', 'Sin spam', 'Descarga inmediata', 'En español'].map(item => <div key={item} className="flex items-center gap-1.5 bg-white/[0.03] border border-white/[0.06] rounded-full px-3 py-1.5" data-id="element-3834" data-mp="367ysqv7w3yc0">
                  <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" data-id="element-3835" data-mp="31g7bxcejd6z2" />
                  <span className="text-[11px] md:text-xs text-gray-400 font-medium truncate" data-id="element-3836" data-mp="2whcm3qi5ii5g">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </section>

        {/* ============ SECTION 2 — PAIN AGITATION ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3837" data-mp="3k76x02iwtwn2">
          <div className="max-w-4xl mx-auto" data-id="element-3838" data-mp="3k89pgevvs753">
            <div className="text-center mb-10 md:mb-12" data-id="element-3839" data-mp="3f8dic6rvzzlb">
              <div className="inline-block text-red-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3840" data-mp="3f6sokjdeckoi">
                Sé Por Qué Estás Aquí
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3841" data-mp="23u9nkydh67f7">
                Esta Guía Es <span className="text-amber-400" data-id="element-3842" data-mp="1yt2gz2n2jea4">Para Ti Si</span>{' '}
                Reconoces Esto:
              </h2>
            </div>

            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-3843" data-mp="jb668t73706z">
              {painPoints.map(p => <li key={p} className="flex items-start gap-3 bg-red-950/20 border border-red-500/15 rounded-xl px-4 py-3.5 md:px-5 md:py-4" data-id="element-3844" data-mp="oaskn5ynimhd">
                  <div className="w-8 h-8 md:w-9 md:h-9 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3845" data-mp="t2ttehwm1v2n">
                    <X className="w-4 h-4 text-red-400" data-id="element-3846" data-mp="121nmvzena5bz" />
                  </div>
                  <span className="text-sm md:text-base text-gray-200 font-medium leading-snug" data-id="element-3847" data-mp="123rx0z3500kp">
                    {p}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 md:mt-10 max-w-2xl mx-auto bg-amber-500/10 border border-amber-500/30 rounded-2xl px-5 py-4 md:px-7 md:py-5 flex items-start gap-3 md:gap-4" data-id="element-3848" data-mp="1by0p5lo99ric">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-amber-500/20 border border-amber-500/40 flex items-center justify-center flex-shrink-0" data-id="element-3849" data-mp="3ds00g71do8v1">
                <Target className="w-4 h-4 md:w-5 md:h-5 text-amber-400" data-id="element-3850" data-mp="134cv6ahb7pcy" />
              </div>
              <p className="text-sm md:text-base lg:text-lg text-amber-100 leading-snug" data-id="element-3851" data-mp="1h3m0ug7w312o">
                Si reconociste{' '}
                <span className="font-black text-amber-400" data-id="element-3852" data-mp="1d3bwt93nqkqg">4 o más</span> —
                esta guía fue escrita EXACTAMENTE para ti.
              </p>
            </div>
          </div>
        </section>

        {/* ============ SECTION 3 — SOLUTION ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3853" data-mp="y503ncfhtu41">
          <div className="max-w-4xl mx-auto" data-id="element-3854" data-mp="y5ta0cajihln">
            <div className="text-center mb-10 md:mb-12" data-id="element-3855" data-mp="teb9fpcfij17">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3856" data-mp="tcqfo1xxv44e">
                La Solución
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3857" data-mp="1nx26byx84yi">
                Hay Un Modelo Que <span className="text-amber-400" data-id="element-3858" data-mp="3nn01n48hb8i0">NADIE</span>{' '}
                Te Está Enseñando.
              </h2>
            </div>

            <div className="bg-gradient-to-br from-amber-950/20 to-[#0a1428] border border-amber-500/30 rounded-3xl p-6 md:p-10 lg:p-12 shadow-[0_0_40px_rgba(245,158,11,0.1)]" data-id="element-3859" data-mp="3sh46nhy6p6gg">
              <p className="text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed mb-6 md:mb-8" data-id="element-3860" data-mp="3iprh4wzuysdl">
                Mientras tú llegas al mismo trabajo todos los días — hay
                empleados latinos como TÚ haciendo algo completamente diferente
                en sus{' '}
                <span className="text-white font-semibold" data-id="element-3861" data-mp="az0jnytutl5">
                  2–3 horas libres
                </span>
                :
              </p>

              <p className="text-xl md:text-2xl lg:text-3xl font-black text-amber-400 leading-tight mb-6 md:mb-8" data-id="element-3862" data-mp="2l17yhl0x39tg">
                Construyen páginas web para negocios locales en USA.
              </p>

              <ul className="space-y-3 md:space-y-3.5 mb-6 md:mb-8" data-id="element-3863" data-mp="wiljdjhlzx0z">
                {[{
                icon: Clock,
                text: 'En 1–2 horas.'
              }, {
                icon: Sparkles,
                text: 'Con inteligencia artificial.'
              }, {
                icon: DollarSign,
                text: 'Las cobran entre $500 y $1,500 cada una.'
              }, {
                icon: Zap,
                text: 'No necesitan saber programar.'
              }, {
                icon: ShieldCheck,
                text: 'No necesitan capital inicial.'
              }, {
                icon: Briefcase,
                text: 'No necesitan dejar su trabajo primero.'
              }].map(item => <li key={item.text} className="flex items-center gap-3 md:gap-4 bg-white/[0.03] border border-white/[0.08] rounded-xl px-4 py-3 md:px-5 md:py-3.5" data-id="element-3864" data-mp="3v0r6bbq2m71g">
                    <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3865" data-mp="1t8co0bjm70ki">
                      <item.icon className="w-4 h-4 text-amber-400" data-id="element-3866" data-mp="20rlo1e68dmww" />
                    </div>
                    <span className="text-sm md:text-base lg:text-lg text-gray-200 leading-snug" data-id="element-3867" data-mp="25pds16k5gzhg">
                      {item.text}
                    </span>
                  </li>)}
              </ul>

              <div className="bg-[#0a1428] border-2 border-amber-500/40 rounded-2xl px-5 py-4 md:px-7 md:py-5 text-center" data-id="element-3868" data-mp="2fg8bk360hkz7">
                <p className="text-sm md:text-base lg:text-lg text-white font-bold leading-snug" data-id="element-3869" data-mp="1hvdtp5erawgd">
                  Lo único que necesitan:{' '}
                  <span className="text-amber-400" data-id="element-3870" data-mp="1rq5pq4soxb91">
                    dedicar 2–3 horas al día durante 60 días.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 4 — CASE STUDIES ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3871" data-mp="384nqyqt225b2">
          <div className="text-center mb-10 md:mb-14" data-id="element-3872" data-mp="387jqgjkjx21m">
            <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3873" data-mp="3taj5cs6mu8w7">
              Casos Reales
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3874" data-mp="6twrzlyj1q8v">
              5 Empleados Latinos Que{' '}
              <span className="text-amber-400" data-id="element-3875" data-mp="22es7188pvph">Ya Lo Lograron</span>:
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6 max-w-6xl mx-auto" data-id="element-3876" data-mp="fta5qqtop0ze">
            {caseStudies.map((c, idx) => <div key={c.name} className="group relative bg-white/[0.025] border border-white/[0.08] rounded-2xl p-5 md:p-6 lg:p-7 hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300 flex flex-col" data-id="element-3877" data-mp="psr4eoaiqelv" data-mpi={idx}>
                {/* Case # */}
                <div className="absolute top-5 right-5 text-amber-400/15 group-hover:text-amber-400/30 transition-colors text-3xl md:text-4xl font-black leading-none" data-id="element-3878" data-mp="2rkns0w9ynex0">
                  0{idx + 1}
                </div>

                {/* Header */}
                <div className="flex items-start gap-3 mb-4 md:mb-5" data-id="element-3879" data-mp="171tqjluwkygr">
                  <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-3880" data-mp="174647mtmomo0">
                    <User className="w-5 h-5 text-amber-400" data-id="element-3881" data-mp="xaz3wgdqvwus" />
                  </div>
                  <div className="min-w-0 pr-10" data-id="element-3882" data-mp="jc942szjjj2q">
                    <h3 className="text-base md:text-lg lg:text-xl font-black text-white leading-tight" data-id="element-3883" data-mp="jevdyz9wmao4">
                      {c.name}, <span className="text-amber-400" data-id="element-3884" data-mp="9ecp1q3hg3zc">{c.age}</span>
                    </h3>
                    <div className="flex items-center gap-1.5 mt-1 text-[11px] md:text-xs text-gray-400" data-id="element-3885" data-mp="edftb8bn2669">
                      <Briefcase className="w-3 h-3" data-id="element-3886" data-mp="23slx9svy5e5v" />
                      <span className="truncate" data-id="element-3887" data-mp="23svo1iotfpcm">{c.role}</span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5 text-[11px] md:text-xs text-gray-400" data-id="element-3888" data-mp="28q5p5vlkhpga">
                      <MapPin className="w-3 h-3" data-id="element-3889" data-mp="3a1nnxhdet0xw" />
                      <span className="truncate" data-id="element-3890" data-mp="3e1eilw62417p">{c.city}</span>
                    </div>
                  </div>
                </div>

                {/* Before */}
                <div className="bg-red-950/20 border border-red-500/15 rounded-xl px-3.5 py-3 mb-2.5" data-id="element-3891" data-mp="3iyo8te19sgwl">
                  <div className="text-[10px] md:text-xs font-black uppercase tracking-[0.16em] text-red-400 mb-1.5 flex items-center gap-1.5" data-id="element-3892" data-mp="3ntby3f43lfc8">
                    <XCircle className="w-3 h-3" data-id="element-3893" data-mp="1jhq8rl59j4u" />
                    Antes
                  </div>
                  <p className="text-xs md:text-sm text-gray-300 leading-snug" data-id="element-3894" data-mp="5lmipmzuw9pw">
                    {c.before}
                  </p>
                </div>

                {/* After */}
                <div className="bg-amber-950/25 border border-amber-500/30 rounded-xl px-3.5 py-3 mb-4" data-id="element-3895" data-mp="27dr5kk2i0gtr">
                  <div className="text-[10px] md:text-xs font-black uppercase tracking-[0.16em] text-amber-400 mb-1.5 flex items-center gap-1.5" data-id="element-3896" data-mp="2cbiwpbvbjyww">
                    <CheckCircle2 className="w-3 h-3" data-id="element-3897" data-mp="24u4cj954aehq" />
                    Hoy
                  </div>
                  <p className="text-xs md:text-sm text-white font-semibold leading-snug" data-id="element-3898" data-mp="20000ibgzvg9s">
                    {c.after}
                  </p>
                </div>

                {/* Quote */}
                <div className="relative bg-[#0a1428] border border-amber-500/20 rounded-xl px-3.5 py-3 mt-auto" data-id="element-3899" data-mp="1q5q66o8hs7wf">
                  <Quote className="absolute -top-2 left-3 w-4 h-4 text-amber-400/40 bg-[#0a1428] px-0.5" data-id="element-3900" data-mp="2npb4s2xjzsso" />
                  <p className="text-xs md:text-sm text-gray-300 italic leading-snug" data-id="element-3901" data-mp="2dthl7zlf2z1e">
                    "{c.quote}"
                  </p>
                </div>
              </div>)}
          </div>

          <p className="mt-10 md:mt-12 text-center text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-3902" data-mp="12ecg6oxtcoem">
            Todos partieron desde CERO. Ninguno tenía capital, conocimientos
            técnicos, o tiempo extra.{' '}
            <span className="text-amber-400 font-black" data-id="element-3903" data-mp="zv7ogp1ybqhd">
              Si ellos pudieron — tú también.
            </span>
          </p>
        </section>

        {/* ============ SECTION 5 — WHAT'S INSIDE ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3904" data-mp="pvgqgde6mtcj">
          <div className="max-w-5xl mx-auto" data-id="element-3905" data-mp="uua6odkusyge">
            <div className="text-center mb-10 md:mb-14" data-id="element-3906" data-mp="usytxo9fkgd5">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3907" data-mp="h353j1ia1o1b">
                Qué Hay Dentro
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3908" data-mp="758xgo475ja2">
                Las 30 Páginas Que Vas A{' '}
                <span className="text-amber-400" data-id="element-3909" data-mp="c4tu2rvw9fjm">Descargar Contienen</span>:
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-3910" data-mp="3uaqcjwfbrfb5">
              {chapters.map(ch => <div key={ch.n} className="group flex items-start gap-4 bg-white/[0.025] border border-white/[0.08] hover:border-amber-500/40 hover:bg-white/[0.04] rounded-xl px-4 py-3.5 md:px-5 md:py-4 transition-all duration-300" data-id="element-3911" data-mp="25cpyewaj9pr">
                  <div className="text-amber-400 font-black text-xl md:text-2xl leading-none flex-shrink-0 w-9 md:w-10" data-id="element-3912" data-mp="3onwhlgk4hyvt">
                    {ch.n}
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-3913" data-mp="3jqxsjcfbgi4h">
                    <h3 className="text-sm md:text-base font-black text-white leading-tight" data-id="element-3914" data-mp="2fwm3iydkmgw">
                      {ch.title}
                    </h3>
                    {ch.desc && <p className="text-xs md:text-sm text-gray-400 mt-1 leading-snug" data-id="element-3915" data-mp="3tl6f7jho1guq">
                        {ch.desc}
                      </p>}
                  </div>
                </div>)}
            </div>

            <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-gray-400" data-id="element-3916" data-mp="l6xwr48uy6ga">
              <span className="flex items-center gap-1.5" data-id="element-3917" data-mp="g95wnmy27e10">
                <FileText className="w-3.5 h-3.5 text-amber-400" data-id="element-3918" data-mp="10a7hj1nk668n" /> 30 páginas
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3919" data-mp="14bsvkqbtwqkf">
                <Globe className="w-3.5 h-3.5 text-amber-400" data-id="element-3920" data-mp="14a9e4wefs9h2" /> 100% en español
              </span>
              <span className="flex items-center gap-1.5" data-id="element-3921" data-mp="193b01od299a5">
                <Download className="w-3.5 h-3.5 text-amber-400" data-id="element-3922" data-mp="1e1vpcsqry8jt" /> Descarga
                inmediata
              </span>
            </div>
          </div>
        </section>

        {/* ============ SECTION 6 — ABOUT GABRIEL ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3923" data-mp="ld8bhi8culga">
          <div className="max-w-5xl mx-auto" data-id="element-3924" data-mp="qcb7kd6cxhc4">
            <div className="text-center mb-10 md:mb-12" data-id="element-3925" data-mp="qagl2uffth5x">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3926" data-mp="vbnsuthkygcl">
                Quién Soy
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3927" data-mp="21tkl6j2t1f5i">
                ¿Quién Soy Y{' '}
                <span className="text-amber-400" data-id="element-3928" data-mp="3r8lnj7veigwu">
                  Por Qué Deberías Escucharme
                </span>
                ?
              </h2>
            </div>

            <div className="bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border border-amber-500/20 rounded-3xl p-6 md:p-10 lg:p-12" data-id="element-3929" data-mp="3hi91tcbuohp4">
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-10 items-center" data-id="element-3930" data-mp="3cie8z38ili1f">
                {/* Avatar */}
                <div className="lg:col-span-2 flex justify-center" data-id="element-3931" data-mp="38j5kodw8ucd9">
                  <div className="relative" data-id="element-3932" data-mp="33hpvqaqy3lpl">
                    <div className="absolute inset-0 bg-amber-400/30 blur-2xl rounded-full" data-id="element-3933" data-mp="33l417ruwob19" />
                    <div className="relative w-40 h-40 md:w-52 md:h-52 lg:w-56 lg:h-56 rounded-3xl bg-gradient-to-br from-amber-400 to-amber-600 border-4 border-amber-500/40 shadow-[0_20px_50px_-15px_rgba(245,158,11,0.5)] overflow-hidden flex items-center justify-center" data-id="element-3934" data-mp="2ylr48eablnky">
                      <User className="w-20 h-20 md:w-28 md:h-28 text-[#0a1428]/60" data-id="element-3935" data-mp="rtqana7ljaxu" />
                    </div>
                    <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#0a1428] border border-amber-500/40 rounded-full px-3 py-1 flex items-center gap-1.5 shadow-xl whitespace-nowrap" data-id="element-3936" data-mp="2m846v3phek19">
                      <Award className="w-3 h-3 text-amber-400" data-id="element-3937" data-mp="2cd2fs2bnb7w1" />
                      <span className="text-[10px] md:text-xs font-black uppercase tracking-tight text-amber-400" data-id="element-3938" data-mp="2hbdqsgdofofu">
                        Gabriel Beltrán
                      </span>
                    </div>
                  </div>
                </div>

                {/* Text */}
                <div className="lg:col-span-3 space-y-3 md:space-y-4 text-sm md:text-base lg:text-[17px] text-gray-300 leading-relaxed" data-id="element-3939" data-mp="2vzrrolrj92tr">
                  <p data-id="element-3940" data-mp="2zz8xxhesa3zz">
                    Soy{' '}
                    <span className="text-white font-bold" data-id="element-3941" data-mp="1kkbjjrtypj6s">
                      Gabriel Beltrán
                    </span>
                    . Creador de{' '}
                    <span className="text-amber-400 font-black" data-id="element-3942" data-mp="1ojk8mje24sw0">
                      AI Web Closer System
                    </span>
                    .
                  </p>
                  <p className="text-white font-semibold" data-id="element-3943" data-mp="1c2j8hzgn7e4c">
                    Pero antes que nada — yo también fui empleado 9-5.
                  </p>
                  <p data-id="element-3944" data-mp="1m1i9cvv625gs">
                    Pasé años en trabajos donde mi tiempo NO era mío. Donde mi
                    sueldo subía 3% al año mientras la vida subía 10%. Donde mi
                    jefe ganaba 5 veces más por sentarse en su oficina.
                  </p>
                  <p data-id="element-3945" data-mp="taqfi51kpswm">
                    En los últimos años he ayudado a{' '}
                    <span className="text-white font-bold" data-id="element-3946" data-mp="182sapbsp7xqb">
                      cientos de empleados latinos en USA
                    </span>{' '}
                    a salir del 9-5 y construir negocios propios desde cero.
                  </p>
                  <p data-id="element-3947" data-mp="amlgtbzrwy4o">
                    Mis alumnos están en{' '}
                    <span className="text-white" data-id="element-3948" data-mp="ak91l6leh1vb">
                      Phoenix, Houston, Miami, Orlando, Dallas, Los Angeles,
                      Chicago
                    </span>
                    .
                  </p>
                  <p className="text-amber-400 font-bold pt-1" data-id="element-3949" data-mp="3v5sydb6pyb2c">
                    Esta guía es mi forma de devolverte 10 años de aprendizaje
                    en 30 páginas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 7 — FAQ ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3950" data-mp="cz4qxeo75bti">
          <div className="max-w-3xl mx-auto" data-id="element-3951" data-mp="hro9yr5nkz5p">
            <div className="text-center mb-10 md:mb-12" data-id="element-3952" data-mp="hrxxm8386u88">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3953" data-mp="mr0tp3189q42">
                FAQ
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight" data-id="element-3954" data-mp="qq1ayh424koy">
                Preguntas <span className="text-amber-400" data-id="element-3955" data-mp="vp4h64vrwwyi">Frecuentes</span>:
              </h2>
            </div>

            <div className="space-y-3 lg:space-y-4" data-id="element-3956" data-mp="2g6vew6setghf">
              {faqs.map((f, idx) => <div key={f.q} className={`bg-white/[0.025] border rounded-2xl overflow-hidden transition-colors ${openFaq === idx ? 'border-amber-500/40' : 'border-white/[0.08]'}`} data-id="element-3957" data-mp="2b8llo1q8wpyg" data-mpi={idx}>
                  <button type="button" onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full flex items-center gap-3 lg:gap-4 px-5 py-4 lg:px-7 lg:py-5 text-left hover:bg-white/[0.015] transition-colors" data-id="element-3958" data-mp="22arzhjm73cp0">
                    <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${openFaq === idx ? 'bg-amber-500/15 border border-amber-500/40' : 'bg-white/[0.04] border border-white/[0.08]'}`} data-id="element-3959" data-mp="2v08os8eiqdh0">
                      <HelpCircle className={`w-4 h-4 lg:w-[18px] lg:h-[18px] ${openFaq === idx ? 'text-amber-400' : 'text-gray-400'}`} data-id="element-3960" data-mp="3io8ed503fxu0" />
                    </div>
                    <span className="flex-1 text-white font-bold text-sm md:text-base lg:text-lg leading-snug" data-id="element-3961" data-mp="3dux6r1ngjd11">
                      {f.q}
                    </span>
                    <ArrowRight className={`w-4 h-4 lg:w-5 lg:h-5 text-gray-500 transition-transform flex-shrink-0 ${openFaq === idx ? 'rotate-90 text-amber-400' : ''}`} data-id="element-3962" data-mp="19ocbfawas6pe" />
                  </button>
                  {openFaq === idx && <div className="px-5 pb-5 lg:px-7 lg:pb-6 pl-[68px] lg:pl-[92px] text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-3963" data-mp="zwzjkjai1gjd">
                      {f.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </section>

        {/* ============ SECTION 8 — FINAL CTA ============ */}
        <section className="mb-16 md:mb-24" data-id="element-3964" data-mp="lzb79zuhzhpx">
          <div className="relative max-w-3xl mx-auto" data-id="element-3965" data-mp="gzf4g3xjdwby">
            <div className="absolute -inset-2 bg-amber-400/20 blur-3xl rounded-3xl pointer-events-none" data-id="element-3966" data-mp="2gbhk1331i6kc" />

            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-6 md:p-10 lg:p-12 text-center shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-3967" data-mp="2bco5r8fxibj4">
              <div className="absolute top-0 right-0 w-40 h-40 bg-amber-400/10 blur-3xl rounded-full" data-id="element-3968" data-mp="2nuh0p0z49k00" />

              <div className="relative" data-id="element-3969" data-mp="2slgye8g2863k">
                <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-3970" data-mp="2smiljbacoj1n">
                  <Clock className="w-3.5 h-3.5 text-amber-400" data-id="element-3971" data-mp="1zxbetp0qsn5b" />
                  <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-widest" data-id="element-3972" data-mp="1zz61p8vkqpc1">
                    Última Llamada
                  </span>
                </div>

                <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-5 max-w-xl mx-auto" data-id="element-3973" data-mp="29ty0uh4t1k8x">
                  ¿Listo Para{' '}
                  <span className="text-amber-400" data-id="element-3974" data-mp="3lb64v1bjgyck">Descargar La Guía</span>?
                </h2>

                <div className="space-y-3 md:space-y-4 text-sm md:text-base lg:text-lg text-gray-300 mb-7 md:mb-8 max-w-lg mx-auto leading-relaxed text-left" data-id="element-3975" data-mp="3pb85d75jflq9">
                  <p data-id="element-3976" data-mp="1q92kkobbc892">Cada día que pasa es un día más en el mismo trabajo.</p>
                  <p data-id="element-3977" data-mp="1l7vhv3o11z99">Un día más viviendo para el viernes.</p>
                  <p data-id="element-3978" data-mp="1z864fuib0rom">Una semana más esperando vacaciones que nunca llegan.</p>
                  <p className="text-white font-semibold" data-id="element-3979" data-mp="1u932wk1j93le">
                    Descargar esta guía NO te cuesta nada.
                  </p>
                  <p className="text-amber-400 font-bold" data-id="element-3980" data-mp="16k1wt3g6a4ja">
                    Pero NO descargarla puede costarte otros 5 años en el 9-5.
                  </p>
                </div>

                <button type="button" onClick={() => setShowModal(true)} className="group relative w-full max-w-md mx-auto bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-2xl py-5 md:py-6 px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden flex" data-id="element-3981" data-mp="1ga3oe57qi52y">
                  <span className="relative z-10 flex items-center justify-center gap-2.5 w-full" data-id="element-3982" data-mp="2uex1p86yf4bd">
                    <Download className="w-5 h-5 md:w-6 md:h-6" data-id="element-3983" data-mp="2z9ujb3iaulzv" />
                    Descargar La Guía Gratis
                    <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" data-id="element-3984" data-mp="2leifm6m61l6t" />
                  </span>
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-3985" data-mp="3e4r1a8fwunq5" />
                </button>

                <div className="mt-5 flex items-center justify-center gap-x-5 gap-y-2 flex-wrap text-xs md:text-sm text-gray-400" data-id="element-3986" data-mp="346b71wll6ycf">
                  <span className="flex items-center gap-1.5" data-id="element-3987" data-mp="397qu1u7brexg">
                    <FileText className="w-3.5 h-3.5 text-emerald-400" data-id="element-3988" data-mp="1sq31dmauz6wj" /> 30
                    páginas
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-3989" data-mp="1xoeatvx8rfe8">
                    <Download className="w-3.5 h-3.5 text-emerald-400" data-id="element-3990" data-mp="2d1789w96aqcb" />{' '}
                    Descarga inmediata
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-3991" data-mp="287ukfocbinkm">
                    <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" data-id="element-3992" data-mp="248lrumt0kvqn" /> Sin
                    spam
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 9 — FEATURED TESTIMONIALS ============ */}
        <section className="mb-8" data-id="element-3993" data-mp="2ryzkaefigwlr">
          <div className="max-w-6xl mx-auto" data-id="element-3994" data-mp="2rvtyp963ccus">
            <div className="text-center mb-10 md:mb-12" data-id="element-3995" data-mp="2mxio2w7z1ybi">
              <div className="inline-block text-amber-400 text-xs md:text-sm font-black uppercase tracking-[0.2em] mb-3" data-id="element-3996" data-mp="2hzh66ema851m">
                Testimonios
              </div>
              <h2 className="text-2xl md:text-4xl lg:text-5xl font-black leading-tight max-w-3xl mx-auto" data-id="element-3997" data-mp="1bkpy9qyqrjy3">
                Lo Que Dicen{' '}
                <span className="text-amber-400" data-id="element-3998" data-mp="wgn7iuswoyon">Personas Que Aplicaron</span>{' '}
                Este Sistema:
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 lg:gap-6" data-id="element-3999" data-mp="11fzq33cqvjlf">
              {featuredTestimonials.map(t => <div key={t.name} className="relative bg-white/[0.025] border border-white/[0.08] hover:border-amber-500/30 rounded-2xl p-5 md:p-6 lg:p-7 transition-all duration-300 flex flex-col" data-id="element-4000" data-mp="16chvm5fwflyt">
                  <div className="flex items-center gap-0.5 mb-4" data-id="element-4001" data-mp="1f8z5l5cj1dsz">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400 fill-amber-400" data-id="element-4002" data-mp="1k82dqynt0056" data-mpi={i} />)}
                  </div>
                  <Quote className="w-6 h-6 text-amber-400/30 mb-3" data-id="element-4003" data-mp="1u3vpwgxm1rmf" />
                  <p className="text-sm md:text-base lg:text-lg text-white font-medium italic leading-snug mb-5 flex-1" data-id="element-4004" data-mp="1u1syptkq1sg4">
                    "{t.quote}"
                  </p>
                  <div className="flex items-center gap-3 pt-4 border-t border-white/[0.06]" data-id="element-4005" data-mp="3vw1y1wzbw6vv">
                    <div className="w-9 h-9 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-4006" data-mp="3nvcgzwab3v47">
                      <User className="w-4 h-4 text-amber-400" data-id="element-4007" data-mp="1nclvzsh0kpt" />
                    </div>
                    <div data-id="element-4008" data-mp="3stx8967kz4gi">
                      <div className="text-white font-black text-sm md:text-base leading-tight" data-id="element-4009" data-mp="3stnqu70lq5mf">
                        {t.name}
                      </div>
                      <div className="text-gray-400 text-[11px] md:text-xs uppercase tracking-wider font-bold mt-0.5" data-id="element-4010" data-mp="alxzrhmzzbk9">
                        {t.detail}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-4011" data-mp="tes5rm2n7tcc" />

      {/* Social proof download notification */}
      <DownloadNotification data-id="element-4012" data-mp="tf1wxczfc6jm" />

      {/* Lead Capture Modal */}
      {showModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in" onClick={() => setShowModal(false)} data-id="element-4013" data-mp="pehze8axv0wy">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)] max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-4014" data-mp="1d0bub7lggrba">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-4015" data-mp="13z499r7y9mz5">
              <X className="w-6 h-6" data-id="element-4016" data-mp="u1purx5l789h" />
            </button>

            <div className="text-center mb-6" data-id="element-4017" data-mp="u3am7dwlub34">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-amber-500/10 border border-amber-500/30 rounded-2xl mb-3" data-id="element-4018" data-mp="gal2xh8gnk9p">
                <Download className="w-6 h-6 text-amber-400" data-id="element-4019" data-mp="kcppjw0hrgmu" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-4020" data-mp="6d6lbeaswpft">
                Descarga Tu Guía
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-4021" data-mp="bd2stnipiz04">
                Ingresa tus datos para recibir acceso inmediato
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-4022" data-mp="lvgad4oq5yp0">
              <div className="space-y-1" data-id="element-4023" data-mp="hsbc5ebogj66">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-4024" data-mp="hr04v4j0wtab">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-4025" data-mp="7udnippwokd1">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-4026" data-mp="7vf6rhh2sd5u">
                    <User className="h-5 w-5 text-gray-500" data-id="element-4027" data-mp="32vmy2rsolsl" />
                  </div>
                  <input ref={nameRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-4028" data-mp="3ub00vvy0h30d" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-4029" data-mp="1vrd25t19pddb">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-4030" data-mp="20r965s9yt4sv">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-4031" data-mp="25rdozoycibm9">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-4032" data-mp="25o7wdzqicrls">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-4033" data-mp="29pl6wn4jpiz1" />
                  </div>
                  <input ref={emailRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-4034" data-mp="1d3hr4gx1idnw" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-4035" data-mp="u9ckglj8x48x">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-4036" data-mp="ybz96dkme91w">
                  WhatsApp (Opcional)
                </label>
                <div className="flex gap-2" data-id="element-4037" data-mp="8y8fkst087dy">
                  <div className="relative w-1/3" data-id="element-4038" data-mp="d27vb96gn269">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-4039" data-mp="czu090bs5pyp">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-4040" data-mp="3v9x9ixyyu1r0" />
                    </div>
                    <select name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-4041" data-mp="43cn5rjuvi0b">
                      {COUNTRY_CODES.map(c => <option key={c.code} value={c.code} className="bg-gray-900" data-id="element-4042" data-mp="3hg60rrt26lwc">
                          {c.code} {c.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-4043" data-mp="37ii4gxft16c2">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-4044" data-mp="37h6ycqyvzmhs">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-4045" data-mp="2ny9i57ash824" />
                    </div>
                    <input ref={phoneRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número (opcional)" autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-4046" data-mp="2jwegg1oy4snt" />
                  </div>
                </div>
              </div>

              <label className="flex items-start gap-3 cursor-pointer group pt-1" data-id="element-4047" data-mp="3gldq9l56i2i4">
                <div className="relative flex-shrink-0 mt-0.5" data-id="element-4048" data-mp="3blrb365sic6o">
                  <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-4049" data-mp="3bmj9eoqruo0n" />
                  <div className="w-5 h-5 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-amber-400 peer-checked:border-amber-400 transition-all flex items-center justify-center" data-id="element-4050" data-mp="3lk75pj4103kx">
                    {smsConsent && <CheckCircle2 className="w-3.5 h-3.5 text-[#0a1428]" strokeWidth={3} data-id="element-4051" data-mp="1gkm51skignp" />}
                  </div>
                </div>
                <span className="text-[11px] md:text-xs text-gray-400 leading-relaxed" data-id="element-4052" data-mp="6f5g4jh8843p">
                  Acepto recibir mensajes SMS con recordatorios e información de
                  esta guía. Puedo cancelar en cualquier momento respondiendo
                  STOP.
                </span>
              </label>

              <button type="submit" disabled={isSubmitting} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-xl py-4 px-6 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed overflow-hidden" data-id="element-4053" data-mp="k5imihegzaqx">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-4054" data-mp="2odddpi88a4zl">
                  {isSubmitting ? <>Enviando...</> : <>
                      <Download className="w-5 h-5" data-id="element-4055" data-mp="2jlvcct2am2e3" />
                      Descargar Ahora
                      <ArrowRight className="w-5 h-5" data-id="element-4056" data-mp="2eobwjopy5hk1" />
                    </>}
                </span>
              </button>

              <div className="flex items-center justify-center gap-1.5 text-xs text-gray-500" data-id="element-4057" data-mp="29qacb0gsbc6z">
                <Lock className="w-3 h-3" data-id="element-4058" data-mp="37bg686zzik25" />
                Tu información está 100% segura
              </div>
            </form>
          </div>
        </div>}
    </div>;
}